export const trimDuplicateSpace = (text: string): any => {
  if (!text) {
    return text
  }
  return text
    .split(' ')
    .filter(x => x !== '')
    .join(' ')
}
